import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import placeholderIcon from './img/content-preview-placeholder-icon.svg';
import squiggle from './img/content-preview-squiggle.svg';

const styles = cssMap({
	container: {
		position: 'relative',
		height: '100%',
	},
	placeholderThumbnail: {
		width: '100%',
		height: '130px',
		backgroundColor: token('color.background.accent.gray.subtlest'),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	squiggleWrapper: {
		marginBlockStart: token('space.250'),
		marginBlockEnd: token('space.300'),
	},
	skeletonBarFull: {
		width: '269px',
		height: '8px',
		backgroundColor: token('color.background.accent.gray.subtlest'),
	},
	skeletonBarShortWrapper: {
		marginBlockStart: token('space.150'),
	},
	skeletonBarShort: {
		width: '148px',
		height: '8px',
		backgroundColor: token('color.background.accent.gray.subtlest'),
	},
	skeletonBarBottom: {
		width: '94px',
		height: '6px',
		backgroundColor: token('color.background.accent.gray.subtlest'),
		position: 'absolute',
		bottom: token('space.0'),
		left: token('space.0'),
	},
});

export const ContentPreviewPlaceholder = () => {
	return (
		<Box xcss={styles.container}>
			<Box xcss={styles.placeholderThumbnail}>
				<img src={placeholderIcon} alt="" aria-hidden="true" width="46" height="46" />
			</Box>
			<Box xcss={styles.squiggleWrapper}>
				<img src={squiggle} alt="" aria-hidden="true" width="84" height="15" />
			</Box>
			<Stack space="space.150">
				<Box xcss={styles.skeletonBarFull} />
				<Box xcss={styles.skeletonBarFull} />
			</Stack>
			<Box xcss={styles.skeletonBarShortWrapper}>
				<Box xcss={styles.skeletonBarShort} />
			</Box>
			<Box xcss={styles.skeletonBarBottom} />
		</Box>
	);
};
